import { ApolloClient, InMemoryCache } from '@apollo/client';

const apolloGraphQlClient = new ApolloClient({
  uri: process.env.VITE_GRAPHQL_URL, // picked from .env file
  cache: new InMemoryCache(),
});

export default apolloGraphQlClient;
